import { Swiper, SwiperSlide } from 'swiper/react';

const ThumbsSwiper = ({
  items,
  setThumbsSwiper,
  tag,
  gap,
  centerInsufficientSlides,
}) => (
  <Swiper
    onSwiper={setThumbsSwiper}
    slidesPerView="auto"
    centeredSlides={false}
    watchSlidesProgress
    spaceBetween={gap}
    allowTouchMove={false}
    role="region"
    className="thumbs-swiper"
    wrapperTag="ul"
    centerInsufficientSlides={centerInsufficientSlides}
    watchOverflow
    loop={false}
  >
    {items.map(({ children }, index) => (
      <SwiperSlide
        role="listitem"
        tag={tag}
        key={`thumbs-slide${index.toString()}`}
        className="thumbs-slide"
        onDragStart={(e) => e.preventDefault()}
        style={{
          width: '84px',
          height: '84px',
        }}
      >
        {children}
      </SwiperSlide>
    ))}
  </Swiper>
);

export default ThumbsSwiper;
